import { useEffect } from 'react'

export const useDebounce = (func: () => void, dependencies: any[], delay: number) => {
    useEffect(() => {
        const handler = setTimeout(() => {
            func()
        }, delay)

        return () => clearTimeout(handler)
    }, [...(dependencies || []), delay])
}
